import React, { forwardRef } from 'react'

import { IconProps } from './types'

const ObjectIcon = forwardRef<SVGSVGElement, IconProps>(
  ({ size, stroke, ...props }, ref) => (
    <svg
      ref={ref}
      width={props.width ?? size}
      height={props.height ?? size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11 2.5C12 2.5 13 3.5 13 4.5V6.5C13 7 13.4 8 15 8C13.4 8 13 9 13 9.5V11.5C13 12.5 12 13.5 11 13.5M5 2.5C4 2.5 3 3.5 3 4.5V6.5C3 7 2.6 8 1 8C2.6 8 3 9 3 9.5V11.5C3 12.5 4 13.5 5 13.5M10.5 7.875H10.25V8.125H10.5V7.875ZM8.125 7.875H7.875V8.125H8.125V7.875ZM5.75 7.875H5.5V8.125H5.75V7.875Z"
        stroke={stroke || 'currentColor'}
      />
    </svg>
  ),
)
ObjectIcon.displayName = 'ObjectIcon'

export default ObjectIcon
